import React from "react";

import Consultant from "../../../models/Consultant";
import { ConsultantTagType } from "../../../models/Organisation";
import { UserLastActivity } from "../../../networking/consultant.hooks";
import ConsultantHeader from "./ConsultantHeader";

const mockTagTypes = [
	{ key: "night-shift", name: { sv: "Nattpass" }, color: "#6366f1" },
	{ key: "driving-license", name: { sv: "Körkort B" }, color: "#0ea5e9" },
	{ key: "senior", name: { sv: "Senior" }, color: "#f59e0b" },
] as ConsultantTagType[];

const mockConsultant = {
	id: "demo-consultant",
	firstName: "Anna",
	lastName: "Andersson",
	email: "anna+66ce119d012b28db4a640c02b5f43859@example-staffing.se",
	active: true,
	profile: {
		employeeNumber: 1247,
		phoneNumber: "0735641240",
		profilePicture: "",
		noOfJobs: 30,
		manager: { firstName: "Anton", lastName: "Anonymous" },
		availability: {
			monday: [],
			tuesday: [],
			wednesday: [],
			thursday: [],
			friday: [],
			saturday: [],
			sunday: [],
		},
		ratings: {
			average: 5,
			count: 1,
			performanceAverage: 5,
			punctualityScoreAverage: 5,
		},
		tags: [{ key: "night-shift" }, { key: "driving-license" }, { key: "senior" }],
	},
} as unknown as Consultant;

const mockLastActivity = {
	appVersion: "1.6.0",
	date: "2026-07-03T18:00:00.000Z",
	platform: "android",
} as UserLastActivity;

const ConsultantHeaderExample: React.FC = () => {
	return (
		<div className="flex flex-col gap-8">
			<div className="rounded-md border border-gray-200 p-6">
				<ConsultantHeader
					consultant={mockConsultant}
					lastActivity={mockLastActivity}
					tagTypes={mockTagTypes}
					onToggleTag={() => {}}
					onUploadProfilePicture={() => {}}
				/>
			</div>

			<div className="rounded-md border border-gray-200 p-6">
				<p className="mb-4 text-sm text-muted-foreground">
					Minimal — no ratings, no manager, no recorded app activity.
				</p>
				<ConsultantHeader
					consultant={
						{
							id: "demo-consultant-2",
							firstName: "Bengt",
							lastName: "Bengtsson",
							email: "",
							active: false,
							profile: { employeeNumber: 1310, noOfJobs: 0 },
						} as unknown as Consultant
					}
					onUploadProfilePicture={() => {}}
				/>
			</div>
		</div>
	);
};

export default ConsultantHeaderExample;
